import RoleManagement from './RoleManagement';

export default RoleManagement;
